import styled from 'styled-components';
import { Link } from 'ui/links';
import { spacing, colors, Caption } from 'ui/theme';
import { Avatar } from 'ui/avatar';
import { fullName } from '../../../utils';
import { MemberRow } from '../types';

const TableCellGrid = styled.div`
  display: grid;
  column-gap: ${spacing.base};
  row-gap: ${spacing.quarter};
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  grid-template-areas: 'avatar name' 'avatar email';
`;

const AvatarLink = styled(Link)`
  align-self: center;
  grid-area: avatar;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

const AvatarSized = styled(Avatar)`
  height: ${spacing.double};
  width: ${spacing.double};
`;

const Name = styled.div`
  grid-area: name;
`;

const Email = styled(Caption)`
  color: ${colors.textSecondary};
  grid-area: email;
`;

export const NameCell = ({ row }: { row: MemberRow }) => (
  <TableCellGrid>
    <AvatarLink useReactRouter href={`/members/${row.userId}`}>
      <AvatarSized firstName={row.firstName} lastName={row.lastName} />
    </AvatarLink>
    <Name>
      <Link inTable useReactRouter href={`/members/${row.userId}`}>
        {fullName(row)}
      </Link>
    </Name>
    <Email>{row.email}</Email>
  </TableCellGrid>
);
